import { formatDate } from "@/common/utils/formatters";
import { EstablishmentProductPriceHistoryData } from "../types/establishmentProductPriceHistory.type";


export class EstablishmentProductPriceHistoriesTransformer {
  static chartTransformer() {
    return (productsPriceHistories: EstablishmentProductPriceHistoryData[]) => {
      return {
        data: productsPriceHistories.map((priceHistory) => {
          return {
            new_value: Number(priceHistory.new_value),
            change_date: formatDate(new Date(priceHistory.change_date), true),
          };
        }),
        kind: 'line_chart',
        title: '',
        subtitle: '',
        primary: {
          query_identifier: 'change_date',
          format_parser: 'date',
        },
        width: 7,
        layout: 'horizontal',
        series_settings: {
          new_value: {
            query_identifier: 'new_value',
            label: 'Valor',
            stack_id: '',
            color: '#0b8ce9',
            format_parser: 'currency',
          },
        },
        tick_settings: {
          y: {
            format_parser: 'currency',
          }
        }
      };
    };
  }
}
